import { Routes } from '@angular/router';
import { LayoutComponent } from './shared/ui/layout/layout.component';
import { NotFoundComponent } from './shared/ui/not-found/not-found.component';
import { authGuard } from './core/guards/auth.guard';
import { EmbeddedBootstrapComponent } from './shared/ui/embedded-bootstrap/embedded-bootstrap';
import { EmbeddedLayoutComponent } from './shared/ui/embedded-layout/embedded-layout';

const appChildren: Routes = [
  {
    path: 'tenants',
    loadChildren: () => import('./features/tenant/tenant.module').then((m) => m.TenantModule),
  },
  {
    path: 'user',
    loadChildren: () => import('./features/user/user.module').then((m) => m.UserModule),
  },
  { path: '', redirectTo: 'tenants', pathMatch: 'full' },
  { path: '**', component: NotFoundComponent },
];

export const routes: Routes = [
  {
    path: 'auth',
    loadChildren: () => import('./features/auth/auth.module').then((m) => m.AuthModule),
  },
  {
    path: 'embedded',
    component: EmbeddedLayoutComponent,
    children: [
      {
        path: '',
        component: EmbeddedBootstrapComponent,
        children: appChildren,
      },
    ],
  },
  {
    path: '',
    component: LayoutComponent,
    canActivate: [authGuard],
    children: appChildren,
  },

  { path: '**', component: NotFoundComponent },
];
